// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-navigation {
  padding: 0 20px;
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Navigations/MobileNavigation/MobileNavigation.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EAGA,wBAAA;AADF","sourcesContent":[".mobile-navigation {\n  padding: 0 20px;\n  \n  // Hide from sidebar - avatar is now in navbar next to History\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
